import type { NumericFormatProps } from 'react-number-format';

import { NumericFormat } from 'react-number-format';
import { twMerge } from 'tailwind-merge';

const LOCALIZED_SETTINGS = {
  de: {
    decimalSeparator: ',',
    thousandSeparator: '.',
  },
};

const MAX_INTEGER_LENGTH = 12;
const MAX_FLOAT_LENGTH = 17;

export type NumberInputProps = {
  onChange?: (value: number | undefined, textValue?: string) => void;
} & Omit<NumericFormatProps, 'onChange'>;

export const NumberInput = (props: NumberInputProps) => {
  const { className, decimalScale, onChange, ...otherProps } = props;
  return (
    <NumericFormat
      className={twMerge('input h-[34px] px-2.5', className)}
      decimalSeparator={LOCALIZED_SETTINGS.de.decimalSeparator}
      maxLength={decimalScale === 0 ? MAX_INTEGER_LENGTH : MAX_FLOAT_LENGTH}
      onValueChange={({ floatValue, value }) => {
        onChange?.(floatValue, value);
      }}
      thousandSeparator={LOCALIZED_SETTINGS.de.thousandSeparator}
      {...otherProps}
    />
  );
};
